import { useAuth, useAppSelector } from '@verantos-dev/core-annotation-tool';

import { useGetSupervisorAllocationSummaryQuery } from '../api/supervisorQueueApiSlice';
import { selectBatchId, selectProjectId } from '../state/selector';
import { SupervisorAllocationSummaryResponse } from '../types/responseTypes';

export interface UseSupervisorQueueHeaderResult {
  supervisorTaskCountData: SupervisorAllocationSummaryResponse | null;
  isSupervisorAllocationSummaryLoading: boolean;
}

export const useSupervisorQueueHeader = (): UseSupervisorQueueHeaderResult => {
  const projectId = useAppSelector(selectProjectId);
  const batchId = useAppSelector(selectBatchId);
  const { user } = useAuth();

  const {
    data: supervisorAllocationSummaryData,
    isLoading: isSupervisorAllocationSummaryLoading,
    isFetching: isSupervisorAllocationSummaryFetching,
  } = useGetSupervisorAllocationSummaryQuery(
    { projectId: projectId as string, batchId: batchId as string },
    { skip: (!user.isUser && !user.isAdmin) || !projectId || !batchId }
  );

  return {
    supervisorTaskCountData: supervisorAllocationSummaryData?.data ?? null,
    isSupervisorAllocationSummaryLoading:
      isSupervisorAllocationSummaryLoading || isSupervisorAllocationSummaryFetching,
  };
};
